import React from "react";
import {
  AccessTime,
  InfoOutlined,
  LocalShippingOutlined,
  MergeType,
} from "@mui/icons-material";
import { Box, Grid, Tooltip, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useDeconsolidationDetailContext } from "contexts/DeconsolidationDetailContext";
import { localizeDateTimeShort } from "utils/dateFormats";

const DeconsolidationBasicDetail = () => {
  const { deconsolidationDetail, loadingDeconsolidation } =
    useDeconsolidationDetailContext();

  return !loadingDeconsolidation ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="ID"
            subtitle={deconsolidationDetail?.deconsolidationId || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment"
            subtitle={
              deconsolidationDetail?.shipmentId ? (
                Array.isArray(deconsolidationDetail.shipmentId) ? (
                  <Tooltip
                    title={
                      <div>
                        {deconsolidationDetail.shipmentId.map(
                          (shipment, index) => (
                            <Typography key={index} variant="body2">
                              {shipment.IsReturning
                                ? `${shipment.shipmentId} (R)`
                                : shipment.shipmentId}
                            </Typography>
                          )
                        )}
                      </div>
                    }
                    arrow
                  >
                    <span>
                      <Typography component="span" variant="body1">
                        {deconsolidationDetail.shipmentId.length > 0
                          ? `${deconsolidationDetail.shipmentId[0].shipmentId}${deconsolidationDetail.shipmentId[0].IsReturning
                            ? " (R)"
                            : ""
                          }`
                          : "Multiple Shipments"}
                      </Typography>
                      {deconsolidationDetail.shipmentId.length > 1 && (
                        <Typography variant="caption" color="textSecondary">
                          +{deconsolidationDetail.shipmentId.length - 1} more
                        </Typography>
                      )}
                    </span>
                  </Tooltip>
                ) : (
                  <Typography component="span" variant="body1">
                    {deconsolidationDetail.shipmentId.IsReturning
                      ? `${deconsolidationDetail.shipmentId.shipmentId} (R)`
                      : deconsolidationDetail.shipmentId.shipmentId}
                  </Typography>
                )
              ) : (
                "N/A"
              )
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <MergeType color="primary" />}
            title="Type"
            subtitle={deconsolidationDetail?.type || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Deconsolidation Time"
            subtitle={localizeDateTimeShort(deconsolidationDetail?.deconsolidationTime)}
          />
        </Grid>
              <Grid item xs={3}>
                  <InformationTile
                    icon={() => <AccessTime color="primary" />}
                    title="Created At"
                    subtitle={localizeDateTimeShort(
                      deconsolidationDetail?.createdAt
                    )}
                  />
                </Grid>
   <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={deconsolidationDetail?.createdBy?.name	 || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Is Active ?"
          >
            <Status isActive={deconsolidationDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default DeconsolidationBasicDetail;
